// extracted by mini-css-extract-plugin
module.exports = {"Error":"Search_Error__EnKQV"};